import { normalizeItemFilterSearch, type ItemFilterSearch } from '@/lib/validation';

export function getItemListFiltersKey(filters: ItemFilterSearch) {
  const normalized = normalizeItemFilterSearch(filters);

  return {
    ...(normalized.query ? { query: normalized.query } : {}),
    ...(normalized.type ? { type: normalized.type } : {}),
    ...(normalized.ui ? { ui: normalized.ui } : {}),
    ...(normalized.tags ? { tags: normalized.tags } : {}),
  };
}

export function getAiSearchFiltersKey(filters: ItemFilterSearch) {
  const normalized = normalizeItemFilterSearch(filters);

  return {
    ...(normalized.query ? { query: normalized.query } : {}),
    ...(normalized.type ? { type: normalized.type } : {}),
    ...(normalized.tags ? { tags: normalized.tags } : {}),
  };
}

export const authKeys = {
  session: ['auth', 'session'] as const,
} as const;

export const itemKeys = {
  all: ['items'] as const,
  list: (filters: ItemFilterSearch) => ['items', 'list', getItemListFiltersKey(filters)] as const,
  aiSearch: (filters: ItemFilterSearch) => ['items', 'ai-search', getAiSearchFiltersKey(filters)] as const,
  detail: (itemId: number) => ['items', 'detail', itemId] as const,
  filters: ['items', 'filters'] as const,
} as const;

export const favoritesKeys = {
  all: ['favorites'] as const,
  list: ['favorites', 'list'] as const,
  ids: ['favorites', 'ids'] as const,
} as const;
